export { ExpandingArea } from '../src/ExpandingArea';
